import { BX } from '../internal/global';
import { addCustomEvent, debug } from '../../core-compatibility';
import { ajax } from './ajax';
import './actions';
import './forms';
import './page';
import { userOptions } from './user-options';

/**
 * Assembly point of `BX.ajax` and `BX.userOptions`.
 *
 * The modules above complete one `ajax` function between them, in this order; `standalone.ts`, the
 * entry of `core_ajax.js`, imports the same list - keep the two in step. What follows runs once,
 * while the kernel loads:
 *
 * - a `BX.ajax` published before the kernel is kept, see below;
 * - every ajax failure goes to `debug`. Both are imported: the published `BX.addCustomEvent` and
 *   `BX.debug` are written by the tail `exports.*` block, after this module has run;
 * - `userOptions` is published by assignment, not by export (PUB-01 exception): an export would
 *   add a generated declaration to `core.d.ts` that shadows `@type/legacy-ajax.d.ts`, whose
 *   signatures the TypeScript consumers are built against;
 * - `ajax` is exported with the type `any`, which keeps `const ajax: any` in `core.d.ts` as it
 *   was for every TypeScript importer of `main.core`.
 */

// A `BX.ajax` published before the kernel is kept with `BX.userOptions`, and the kernel does not
// subscribe again, as the old `core_ajax.js` glued into `core.js` did. `core_ajax.js` loaded first
// publishes one that may hold a pending configuration and unsent options; `localcore.js` of the
// mobile app publishes its own in local web components, with `BX.ajax.send` that `BX.rest` calls.
const loadedAjax: any = BX.ajax || null;

if (!loadedAjax)
{
	(addCustomEvent as any)('onAjaxFailure', debug);

	BX.userOptions = userOptions;
}

const published: any = loadedAjax || ajax;
export { published as ajax };
